import { render, staticRenderFns } from "./ContextMenuItem.vue?vue&type=template&id=7544ce5b&"
import script from "./ContextMenuItem.vue?vue&type=script&lang=ts&"
export * from "./ContextMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7544ce5b')) {
      api.createRecord('7544ce5b', component.options)
    } else {
      api.reload('7544ce5b', component.options)
    }
    module.hot.accept("./ContextMenuItem.vue?vue&type=template&id=7544ce5b&", function () {
      api.rerender('7544ce5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/src/overlays/ContextMenuItem.vue"
export default component.exports